module.exports = __webpack_public_path__ + "static/media/dropoff_active.8a21cfcf.svg";